// extracted by mini-css-extract-plugin
module.exports = {"component":"NavigationIcon_component__36-h7"};